export function ini_set (varname, newvalue) {
  //  discuss at: http://phpjs.org/functions/ini_set/
  // original by: Brett Zamir (http://brett-zamir.me)
  //        note: This will not set a global_value or access level for the ini item
  //   example 1: ini_set('date.timezone', 'Asia/Hong_Kong');
  //   example 1: ini_set('date.timezone', 'America/Chicago');
  //   returns 1: 'Asia/Hong_Kong'

    let oldval = '';
    const self = this;

    try {
    window.php_js = window.php_js || {}
  } catch (e) {
    window.php_js = {}
  }

  window.php_js.ini = window.php_js.ini || {}
  window.php_js.ini[varname] = window.php_js.ini[varname] || {}

  oldval = window.php_js.ini[varname].local_value

    const _setArr = function (oldval) {
        // Although these are set individually, they are all accumulated
        if (typeof oldval === 'undefined') {
            self.php_js.ini[varname].local_value = []
        }
        self.php_js.ini[varname].local_value.push(newvalue)
    };

    switch (varname) {
    case 'extension':
      if (typeof window.dl === 'function') {
      // This function is only experimental in php.js
        window.dl(newvalue)
      }
      _setArr(oldval, newvalue)
      break
    default:
      window.php_js.ini[varname].local_value = newvalue
      break
  }

  return oldval
}
